import { render, staticRenderFns } from "./YouTubeStarSummaryCard.vue?vue&type=template&id=1e5072f0&scoped=true"
import script from "./YouTubeStarSummaryCard.vue?vue&type=script&lang=js"
export * from "./YouTubeStarSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./YouTubeStarSummaryCard.vue?vue&type=style&index=0&id=1e5072f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5072f0",
  null
  
)

export default component.exports